export default __webpack_public_path__ + "static/media/slide2.8a113bde.png";